import { Button } from 'component/Button'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { store } from 'store/store'

export const CloseButton = observer(() => {
  const { tablet } = store.frame
  const pin = tablet ? 16 : 8

  const onClick = useLatestCallback(() => {
    store.state = 'none'
  })

  return <Space pin={[pin, pin, null, null]}>
    <Button text size={tablet ? 56 : 80} onClick={onClick}>
      <Icon size={tablet ? 24 : 32} name="close" />
    </Button>
  </Space>
})
